import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { SellCommonCard } from 'components/commonCard/SellCommonCard';
import { MyCardsSelectionMode } from 'lib/my-cards';

import type { TokenCommonDetails_anyCard } from './__generated__/index.graphql';

type Props = {
  anyCard: TokenCommonDetails_anyCard;
  selectionMode?: MyCardsSelectionMode;
  onToggleCard?: (slug: string, options?: { xpNeeded?: number }) => void;
  selected?: boolean;
};

export const TokenCommonDetails = ({
  anyCard,
  onToggleCard,
  selectionMode,
  selected,
}: Props) => {
  return (
    <>
      {selectionMode === 'drop' && (
        <SellCommonCard
          card={anyCard}
          onSelect={() => onToggleCard?.(anyCard.slug)}
          selected={selected}
        />
      )}
    </>
  );
};

TokenCommonDetails.fragments = {
  anyCard: gql`
    fragment TokenCommonDetails_anyCard on AnyCardInterface {
      slug
      ...SellCommonCard_anyCard
    }
    ${SellCommonCard.fragments.anyCard}
  ` as TypedDocumentNode<TokenCommonDetails_anyCard>,
};
